import { Circle, Html } from '@react-three/drei';
import React from 'react';
export var debounce = function (callback, delay) {
    var timeoutId = null;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(function () {
            callback();
        }, delay);
    };
};
export var ShapeThreeRendering = function (_a) {
    var position = _a.position, color = _a.color, text = _a.text, circleShape = _a.circleShape;
    var HEIGHT = 8;
    var ELEVATION = 0;
    var positionZ = HEIGHT / 2 + ELEVATION;
    var _b = React.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var debouncedHandlePointerOver = debounce(function () {
        setIsHovered(true);
    }, 300);
    var debouncedHandlePointerOut = debounce(function () {
        setIsHovered(false);
    }, 300);
    var scaleFactor = isHovered ? 2 : 1.0;
    return (React.createElement(React.Fragment, null, circleShape ? (React.createElement(Circle, { args: [0.3, 64], position: [position[0], position[1], positionZ] },
        React.createElement("meshBasicMaterial", { color: color }))) : (React.createElement("group", { position: position },
        React.createElement("mesh", { position: [0, 0, positionZ], scale: [0.5, 0.5, 0.5], onPointerOver: debouncedHandlePointerOver, onPointerOut: debouncedHandlePointerOut },
            isHovered && (React.createElement(Html, { zIndexRange: [1] },
                React.createElement("div", { style: {
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.6rem',
                        transform: "scale(".concat(scaleFactor, ")"),
                        transition: 'transform 0.3s',
                    } }, text))),
            React.createElement("boxGeometry", { args: [1.3, 1.3, 1.3] }),
            React.createElement("meshStandardMaterial", { color: color, opacity: 0.6, transparent: true }))))));
};
